// React
import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Reactstrap
import { Col, Row } from 'reactstrap';

// components
import { CardList } from '../../components/card_list';
import { FloatButton } from '../../components/floatButton';
import { PageWrapper } from '../../components/pageWrapper';
import { ModalInputAnimation } from '../../components/modalInput';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  Specialties as SpecialtyDispatch,
  CreateSpecialties,
  UpdateSpecialties,
  DeleteSpecialties,
} from '../../store/actions';

// assets
import avatar from '../../assets/images/users/user-pic.jpg';

const Specialties = () => {
  const [selectSpecialty, setSelectSpecialty] = useState('');

  const [modal_animationLeft, setmodal_animationLeft] = useState(false);
  function tog_animationLeft() {
    setSelectSpecialty('');
    setmodal_animationLeft(!modal_animationLeft);
  }

  const dispatch = useDispatch();
  const history = useHistory();

  const { specialties, success } = useSelector((state) => ({
    error: state.Specialties.error,
    specialties: state.Specialties.specialties,
    success: state.Specialties.success,
  }));

  const handleSubmit = (e) => {
    if (selectSpecialty === '') {
      e.preventDefault();
      dispatch(
        CreateSpecialties({
          name: e.target.typeName.value,
        })
      );
      tog_animationLeft();
    } else {
      e.preventDefault();
      dispatch(
        UpdateSpecialties({
          id: selectSpecialty.id,
          data: {
            name: e.target.typeName.value,
          },
        })
      );
      tog_animationLeft();
    }
  };

  const handleDelete = (values) => {
    const { id } = values;

    dispatch(DeleteSpecialties(id));
  };

  const handleEdit = (values) => {
    const { id, name } = values;

    setmodal_animationLeft(true);

    setSelectSpecialty({
      id: id,
      name: name,
    });
  };

  useEffect(() => {
    dispatch(SpecialtyDispatch());
  }, [dispatch, success]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <img
                src={cell.photo || avatar}
                alt=""
                className="rounded-circle"
                width="30"
                height="30"
                style={{
                  marginRight: '10px',
                }}
              />
              <Link to="#" className="currency_name">
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  return (
    <PageWrapper title={'Especialidades'}>
      <Row>
        <Col xs={12}>
          <CardList
            data={specialties ? specialties : []}
            title="Especialidades"
            titleButton="Nova especialidade"
            handleButton={tog_animationLeft}
            columns={columns}
            pagination
            persistTableHead
            perPage={10}
            isSearchRemote={false}
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => handleEdit(cellProps),
                icon: 'las la-pen',
                classNameColorIcon: 'primary',
              },
            ]}
            handleDelete={(cellProps) => handleDelete(cellProps)}
          />
        </Col>
      </Row>
      <ModalInputAnimation
        toogle={tog_animationLeft}
        title={
          selectSpecialty ? 'Editar Especialidade' : 'Adicionar Especialidade'
        }
        isOpen={modal_animationLeft}
        value={selectSpecialty ? selectSpecialty.name : ''}
        label="Nome da especialidade"
        handleSubmit={handleSubmit}
      />
      <FloatButton handleButton={tog_animationLeft} />
    </PageWrapper>
  );
};

export default Specialties;
